export function removeNonNumericCharacters(value = ''): string {
  return value?.replace(/[^\d]/g, '')
}
